import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import {scrollToggleFixed} from '../../utils/scrollFixedNav';
import {iniciarContadorDesdeFechaBase, iniciarContadorEvitadoDesdeFechaBase} from '../../utils/counter-kilos.js';

document.addEventListener('DOMContentLoaded', function ()
{
    scrollToggleFixed({
        navSelector: '#navbar',
        targetSelector: '#hero',
    });

    const initSwiper = () => {
        let swiperInstance = new Swiper('.swiper-servicio-panelizado', {
            loop: true,
            slidesPerView: 1,
            // autoplay: true,
            // speed: 3000,
            navigation: {
                prevEl: '.swiper-button-prev-servicio-panelizado',
                nextEl: '.swiper-button-next-servicio-panelizado',
            },
            breakpoints: {
                320: {
                    slidesPerView: 1,
                    spaceBetween: 15
                },
                768: {
                    spaceBetween: 15,
                },
                1280: {
                    spaceBetween: 0,
                },
                1920: {
                    spaceBetween: 0,
                },
            },
        });
    };

    const swiperLinea = new Swiper('.swiper-lineas', {
        loop: true,
        slidesPerView: 2,
/*        autoplay: true,
        speed: 2000,*/
        navigation: {
            prevEl: '.swiper-button-prev-lineas',
            nextEl: '.swiper-button-next-lineas',
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 15,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 15,
            },
            1280: {
                slidesPerView: 2,
                spaceBetween: 25,
            },
        },
    });

    const breakpoint = window.matchMedia('(min-width: 80rem)');
    const swiperConfigs = [
        {
            selector: '.swiper-kits',
            prevEl: '.swiper-button-prev-kits',
            nextEl: '.swiper-button-next-kits',
            options: {
                loop: true,
                slidesPerView: 4,
                navigation: {},
                breakpoints: {
                    320: { slidesPerView: 1 },
                    768: { slidesPerView: 1, spaceBetween: 15 },
                    1280: { slidesPerView: 3, spaceBetween: 25 },
                    1920: { slidesPerView: 4, spaceBetween: 35 },
                },
            },
        },
        {
            selector: '.swiper-terminaciones',
            prevEl: '.swiper-button-prev-terminaciones',
            nextEl: '.swiper-button-next-terminaciones',
            options: {
                loop: true,
                slidesPerView: 4,
                navigation: {},
                breakpoints: {
                    320: { slidesPerView: 1 },
                    768: { slidesPerView: 1, spaceBetween: 15 },
                    1280: { slidesPerView: 3, spaceBetween: 25 },
                    1920: { slidesPerView: 4, spaceBetween: 35 },
                },
            },
        },
        {
            selector: '.swiper-servicio-panelizado',
            prevEl: '.swiper-button-prev-servicio-panelizado',
            nextEl: '.swiper-button-next-servicio-panelizado',
            options: {
                loop: true,
                slidesPerView: 1,
                navigation: {},
                breakpoints: {
                    320: { slidesPerView: 1, spaceBetween: 15 },
                    768: { spaceBetween: 15 },
                    1280: { spaceBetween: 0 },
                    1920: { spaceBetween: 0 },
                },
            },
        },
    ];

    const swiperInstances = new Map();

    function initAllSwipers() {
        swiperConfigs.forEach(({ selector, prevEl, nextEl, options }) => {
            const elements = document.querySelectorAll(selector);

            elements.forEach((el) => {
                if (swiperInstances.has(el)) return;

                const opts = {
                    ...options,
                    navigation: {
                        prevEl: el.parentElement.querySelector(prevEl),
                        nextEl: el.parentElement.querySelector(nextEl),
                    },
                };

                const instance = new Swiper(el, opts);
                swiperInstances.set(el, instance);
            });
        });
    }

    function destroyAllSwipers() {
        swiperInstances.forEach((instance, el) => {
            instance.destroy(true, true);
            swiperInstances.delete(el);
        });
    }

    function handleBreakpointChange() {
        if (breakpoint.matches) {
            destroyAllSwipers();
        } else {
            initAllSwipers();
        }
    }

    // Inicializar comportamiento con breakpoint
    breakpoint.addEventListener('change', handleBreakpointChange);
    handleBreakpointChange();

    iniciarContadorDesdeFechaBase();
    iniciarContadorEvitadoDesdeFechaBase()
});
